// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"0e2719c4","228":"a78e4105","398":"cad0d31b","517":"eaedfe16","734":"e1baed06","751":"374a6a73","825":"3527cbbd","917":"c7ffdb44","959":"9dbb021a"}[chunkId] + ".chunk.js";
};